import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup,  NgForm } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { EnvioService } from 'app/main/wizard-cgo/services/envio.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import { AlertDialogComponent } from 'app/main/pagina/certificar/alertdialog/alertdialog.component';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
//SERVICE
import { DispatchService } from 'app/main/pagina/pulse/services/dispatch.service';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_dispatch } from 'app/idiomas/i18n/dispatch/dispatch.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import Swal from 'sweetalert2';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {FormControl,  Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';


interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};

@Component({
    selector     : 'dispatch',
    templateUrl  : './dispatch.component.html',
    styleUrls    : ['./dispatch.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations : fuseAnimations
})
export class DispatchComponent implements OnInit {

  dialogRef: any;
  form: FormGroup;
  centered = false;
  disabled = false;
  unbounded = false;
  clave : string = '';
  url : string = '';
  radius: number;
  color: string;
  flag: boolean = false;

  // Datos certificar vigente
  // productoCertificar: backInter.prodCert;
  productoPulse: backInter.prodPulseCheck;
  encuestasFocusdemo: backInter.encuestaPilotoFocus;

  //boolean paso completo
  pasoCompleto = false;
  idiomas: any[] = [];

  correosPilotos: any[] = [
    {email:'', idioma:''},
    {email:'', idioma:''},
    {email:'', idioma:''},
    {email:'', idioma:''},
    {email:'', idioma:''}
  ];
  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';
  charIdiomas = this.charChinos + this.charTurcos;
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");

  userData:any;
  validationUser:boolean=false;
  desbloqueoEstatus:boolean=false;

  constructor(
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    private envioService: EnvioService,
    private service : DispatchService,
    private mail_service : DispatchService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService,
    private programacionService: ProgramacionService,
    private _snackBar: MatSnackBar,
  ){

  lang_dispatch.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
  });

  if(localStorage.getItem('userBypass')){
  this.userData=JSON.parse(localStorage.getItem('userBypass'));
  // console.log(this.userData.level);
  if(this.userData.level==3 || this.userData.level==2){
    this.validationUser=true;
  }
  else{
    this.validationUser=false;
  }
  }

        //console.log(this._translateService.instant('data.SHEDULE.TITLE1'));




  }
  ngOnInit() {
    this.obtieneCertificarActual();


    // this.form = this._formBuilder.group({
    //   email01: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    //   email02: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    //   email03: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    //   email04: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    //   email05: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    // });
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.envioService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsPulse:backInter.prodPulseCheck[] = data.productosPulseCheck;
      var BreakException = {};
      try {
          prodsPulse.forEach( (producto) => {
            let fecha = producto.fechaPulseCheck;
            let idProducto = producto.idPulseCheck;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoPulse = producto;
              this.getEstatusDesbloqueo();
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.envioService.getStatusEnvioPulse(this.productoPulse.idPulseCheck).subscribe( (data: backInter.getStatusIndiv) => {

        if(data.estatus === 3)

          this.pasoCompleto = true;
      });

      let datos: any = { productoId:this.productoPulse.idPulseCheck };
      this.programacionService.getIdiomasProdPulse(datos).subscribe( (respuesta: backInter.getIdiomas) => {
        console.log("getIdiomasProd:",respuesta);
        respuesta.idiomasMostrar.forEach(idioma => {
          if(idioma.tipoIdioma != "3"){
            this.idiomas.push(idioma);
          }
        });
      });

      this.getStatusModal();
      this.getPilotoData();
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getStatusModal(){
    let datos={
      productoId: this.productoPulse.idPulseCheck,
      envio: 1
    };
    console.log(datos);
    this.wizardService.getStatusModalPulse(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
            this.modalInformativo('ENVIO');
      }
    });
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoPulse.idPulseCheck,
      envio: 2
    };
    // console.log(datos);
    this.wizardService.updateStatusModalPulse(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  completarPaso(){
    if(this.pasoCompleto){
      this.aletaRestric('ENVIO.COMPLETADO',null,'warning');
    }
    else{
      if(this.flag){
        this.aletaRestric('ENVIO.COMPLETAR',true);
      }
      else{
        this.aletaRestric('ENVIO.NADA',null,'warning');
      }
      //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
    }

  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoPulse.idPulseCheck).subscribe((respuesta:any) => {
      // console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus=true;
      }
      else{
        this.desbloqueoEstatus=false;
      }
    });
  }

  desbloquearEnvio(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ENVIO.TITULO_DESBLOQUEAR';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ENVIO.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ENVIO.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ENVIO.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ENVIO.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ENVIO.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          this.envioService.desbloquearPasoEnvioPulse(this.productoPulse.idPulseCheck).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '216'){
               this.pasoCompleto = false;
               this.enviaOrdenWizard();
               this.openSnackBar(succes,"OK");
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,
               
               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,
        
        confirmButtonText: cerrar,
        })
      }
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.envioService.guardaStatusEnvioPulse(this.productoPulse.idPulseCheck).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '216'){
              this.aletaRestric('ENVIO.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      if(tipoMsg=='success'){
        this.openSnackBar(texto,"OK");
      }else if (tipoMsg=="'warning") {
        let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
        this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
        this._snackBar.open(textomessage, "Ok", {
          duration: 2000,
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ['background-red']
        });

      }else{
        Swal.fire({
          title: texto,
          icon: tipoMsg,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });
      }
      /*Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });*/
    }

  }

  openDialog(): void {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '250px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

    });
  }

  private sendMail(){
        let data={
          productoId: this.productoPulse.idPulseCheck,
        };
        this.service.sendMail(data).subscribe(response => {
            console.log(response);

        }, error => {
          //console.log(error);
        });

  }

 getPilotoData(){
        let data={productoId: this.productoPulse.idPulseCheck};
        console.log(this.productoPulse.idPulseCheck);
        console.log(data);
        this.service.getPilotoData(data).subscribe((response: backInter.encuestaPilotoFocus )=> {
          this.encuestasFocusdemo=response;
              console.log(response);
              // if(response['message'] = "Success"){
              //   this.clave = response['data[0]']['userDemo'];
              //   // this.url = response['data']['url'];
              //   if(response['estatusEnvio'] == 3){
              //     this.flag = true;
              //   }else{
              //     this.flag = false;
              //   }
              // }


            }, error => {
              console.log(error);
            });

  }

  showAlert(): void {
        // this.dialogRef = this.dialog.open(AlertDialogComponent, {
        //   data: {'header': 'Info','message':'Do you want to continue with the shipment?','cancel':'No, cancel','accept':'Ok, send'}
        // });
        //
        // this.dialogRef.afterClosed()
        //     .subscribe(result => {
        //     if(result == 'true'){
        //       this.sendMail();
        //       this.flag = true;
        //     }else{
        //       console.log('false');
        //       this.flag = false;
        //     }
        //   });
        let texto = 'DISPATCH.ALERT.MESSAGE';
        let rspSi = 'DISPATCH.ALERT.BTN_CONFIRM';
        let rspNo = 'DISPATCH.ALERT.BTN_CANCEL';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
        this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
        Swal.fire({
          title: texto,
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          
          
          confirmButtonText: rspSi,
          cancelButtonText: rspNo
        }).then((result) => {
          if (result.value) {
            this.sendMail();
            this.flag = true;
          }
        });
    }

    validarDato(dato:any,numCampo:number){
      let datoCorrecto = true;
      datoCorrecto = this.regexEmail.test(dato.target.value);
      if(!datoCorrecto){
        this.mensajeSwal(this.translateSrv.instant('DISPATCH.ALERT.ERRMAIL'), 2);
        this.correosPilotos[numCampo].email = "";
      }
    }

    enviaPilotos(){
      console.log("pilotos:",this.correosPilotos);
      let correctos = true;
      let datos: any = {
        productoId: localStorage.getItem('productoID'),
        correos: []
      };
      let BreakException = {};
      try {
        this.correosPilotos.forEach(correo => {
          if(correo.email != ""){
            if(correo.idioma != ""){
              datos.correos.push(correo);
            }
            else{
              this.mensajeSwal(this.translateSrv.instant('DISPATCH.ALERT.SINLANG'),2);
              correctos = false;
              throw BreakException;
            }
          }
        });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      if(correctos){
        console.log("datosAEnviar:",datos);
        this.mail_service.pilotoSMTP(datos).subscribe((respuesta:any) => {
          console.log("sendPilotoSMTP:",respuesta);
          if(respuesta.message = "Success"){
            let texto = 'DISPATCH.LABEL06'+'';
            let newTexto:string;
            this.translateSrv.get(texto).subscribe((res: string) => { newTexto = res; });
            this.openSnackBar(newTexto,"OK");
            /*Swal.fire({
              title: newTexto,
              icon: "success",
              confirmButtonColor: '#e40601'
            });*/
          }
        });
      }
    }

    mensajeSwal(mensaje:string, tipoMsg:number){
      let tipo: any;
      let rspSi = 'MODALES.ACCIONES.aceptar';
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      switch(tipoMsg){
        case 1: tipo = 'success'; break;
        case 2: tipo = 'warning'; break;
        case 3: tipo = 'error'; break;
      }
      if(tipoMsg == 1){
        this.openSnackBar(mensaje,"OK");
      }else{
        Swal.fire({
          title: mensaje,
          icon: tipo,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });
      }

    }
    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 2000,
      });
    }

  email01:any;
  playerName="";

  getEmails(e){
    e.preventDefault();
    // if(this.form.valid){
      console.log("Diferentes email");
      let email01:string;
      let email02:string;
      let email03:string;
      let email04:string;
      let email05:string;
      if($("#email01").val().length>0){
        email01=$("#email01").val();
      }
      else{
        email01="localhost@localhost.com"
      }

      if($("#email02").val().length>0){
        email02=$("#email02").val();
      }
      else{
        email02="localhost@localhost.com"
      }

      if($("#email03").val().length>0){
        email03=$("#email03").val();
      }
      else{
        email03="localhost@localhost.com"
      }

      if($("#email04").val().length>0){
        email04=$("#email04").val();
      }
      else{
        email04="localhost@localhost.com"
      }

      if($("#email05").val().length>0){
        email05=$("#email05").val();
      }
      else{
        email05="localhost@localhost.com"
      }
      let data={
        productoId: this.productoPulse.idPulseCheck,
        'correos':[
          {
            "email":email01
          },{
            "email":email02
          },{
            "email":email03
          },{
            "email":email04
          },{
            "email":email05
          },
        ]
      };
      /*this.envioService.sendEmail_CF(data).subscribe((data:backInter.infoProductos) => {
          console.log(data);
      });*/


      this.mail_service.sendEmailPulse(data)
      .subscribe(response=> {
        console.log(response);
        if(response['message'] = "Success"){
          let texto = 'DISPATCH.LABEL06'+'';
          let newTexto:string;
          this.translateSrv.get(texto).subscribe((res: string) => { newTexto = res; });
          this.openSnackBar(newTexto,"OK");
          /*Swal.fire({
            title: newTexto,
            icon: "success",
            confirmButtonColor: '#e40601'
          });*/
        }
      });


    // }else{
    //   let texto = 'DISPATCH.LABEL05'+'';
    //   let newTexto:string;
    //   this.translateSrv.get(texto).subscribe((res: string) => { newTexto = res; });
    //   console.log(newTexto);
    //   Swal.fire({
    //     title: newTexto,
    //     icon: "error",
    //     confirmButtonColor: '#e40601'
    //   });
    //
    // }



  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

}
